import html from "./CancelAccount.html"
import "./CancelAccount.css"

var module = angular.module("ResearchKitApplicationModule");

module.component('cancelAccount', {
	template: html,
	bindings: {
		promptIsVisible: '='
	},
	controller: 'cancelAccountController',
	controllerAs: 'vm'
});

module.controller("cancelAccountController", ["$scope", "$http", "ceUrl", "$translate",
	function ($scope, $http, ceUrl, $translate) {
		var vm = this;
		vm.spinnerIsVisible = false;

		vm.showPrompt = function () {
			vm.promptIsVisible = true;
		}
		vm.hidePrompt = function () {
			vm.promptIsVisible = false;
		}

		vm.cancelAccount = function () {

			vm.spinnerIsVisible = true;

			var confirmMessage;
			$translate('account-deleted-confirm-message')
				.then(function (translatedValue) {
					confirmMessage = translatedValue;
				});

			$http.post(ceUrl.make("api/cfhrfulldeletemyaccount"))
				.then(function (result) {
					alert(confirmMessage);
					vm.promptIsVisible = false;
					vm.spinnerIsVisible = false;
					ActiveLogout.Logout(true);
				});
		}
	}
]);